export default "__VITE_ASSET__b60e5acd__"